export { COOKIE_NAME, ONE_YEAR_MS } from "@shared/const";

export const getLoginUrl = () => {
  return "/login";
};

export const getRegisterUrl = (role: string, _registrationData?: Record<string, unknown>) => {
  const params = new URLSearchParams();
  if (role) {
    params.set("role", role);
  }
  return params.toString() ? `/register?${params.toString()}` : "/register";
};
